export const REFERENCE_MODEL = "reference";
import { REFEREE, APPLICATION } from "@/models/relationships";

const referenceModel = {
  referenceTypeName: "",
  periodStartDate: "",
  periodEndDate: "",
  referenceReceivedDate: "",
  referee_user_id: "",
  status: "",
  user: {
    jsonApi: "hasOne",
    type: "users"
  },
  experience: {
    jsonApi: "hasOne",
    type: "experiences"
  },
  referee: {
    jsonApi: "hasOne",
    type: REFEREE
  },
  application: {
    jsonApi: "hasOne",
    type: APPLICATION
  },
  conversations: {
    jsonApi: "hasMany",
    type: "conversations"
  },
  applications: {
    jsonApi: "hasMany",
    type: "applications"
  },
  offer: {
    jsonApi: "hasOne",
    type: "offers"
  }
};

export default referenceModel;
